import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { ShopEditInformationTemplate } from 'components/Templates'
import { fetchShop } from 'reducks/shop/operations'
import { getShopRef, getStoreName } from 'reducks/store/selectors'
import { fetchStore } from 'reducks/store/operations'
import { db } from 'firebase/index'
import { updateEditState } from 'reducks/confirm/operations'
import { getIsBeingEdited } from 'reducks/confirm/selectors'

const ShopEditInformation: FC = () => {
  const dispatch = useDispatch()

  const name = useSelector((state: State) => getStoreName(state))
  const shopRef = useSelector((state: State) => getShopRef(state))
  const isBeingEdited = useSelector((state: State) => getIsBeingEdited(state))

  const path = useSelector((state: State) => state.router.location.pathname)
  const isCreatePage = /\/admin\/shops\/create\/information/.test(path)
  const storeId = isCreatePage
    ? undefined
    : path.split('/admin/shops/')[1]
    ? path.split('/admin/shops/')[1].split('/information')[0]
    : undefined

  useEffect(() => {
    if (!storeId || isBeingEdited) return
    dispatch(fetchStore(db.collection('stores').doc(storeId)))
    dispatch(updateEditState(true))
  }, [])

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShop(shopRef.id))
  }, [shopRef])

  return (
    <Layout
      headline={isCreatePage ? '新規店舗作成' : undefined}
      title={isCreatePage ? '新規店舗の基本情報を編集' : `${name}の基本情報を編集`}
    >
      <ShopEditInformationTemplate
        isCreatePage={isCreatePage}
        isEventPage={false}
        isEditedByOwner={false}
        storeId={storeId ?? db.collection('stores').doc().id}
      />
    </Layout>
  )
}

export default ShopEditInformation
